import React, { Component } from 'react';
import { injectStripe, CardNumberElement, CardCVCElement, CardExpiryElement, PostalCodeElement } from 'react-stripe-elements';


const StripeStyle = {
  base:
    {
      fontSize: '18px',
    }
  }


class CheckoutForm extends Component {

  fullName=(customer) => {
    let attributes = customer['attributes']
    return `${attributes['firstName']} ${attributes['lastName']}`
  }

  handleSubmit = (ev) => {
    ev.preventDefault();

    // Within the context of `Elements`, this call to createToken knows which Element to
    // tokenize, since there's only one in this group.
    this.props.stripe
      .createToken(
        {
          name: this.fullName(this.props.customer)
        }
      )
      .then((response) => {
        this.props.checkout(response.token, this.props.order['id'])
      })
      .catch(error => {
        console.log(error)
      })
  }

  render() {
    return (
      <div className={'checkout-information'}>
        <form onSubmit={this.handleSubmit}>
          <div>
            <label> Card Number </label>
            <CardNumberElement style={ StripeStyle } className={'km-field form-control'}/>
            <label> Card CVC </label>
            <CardCVCElement style={ StripeStyle } className={'km-field form-control'}/>
            <label> Expiration Date </label>
            <CardExpiryElement style={ StripeStyle } className={'km-field form-control'}/>
            <label> Postal Code </label>
            <PostalCodeElement style={ StripeStyle } className={'km-field form-control'}/>
            <button disabled={ this.props.loading ? true : false } className={ this.props.loading ? 'disabled checkout-button' : 'checkout-button' }>
              Checkout
            </button>
          </div>
        </form>
      </div>
    )
  }
}

export default injectStripe(CheckoutForm)



// WEBPACK FOOTER //
// ./src/CheckoutForm.jsx